import React, {createContext, ReactNode, useContext} from 'react';

interface RuntimeConfig {
  TURNSTILE_SITE_KEY: string;
}

interface ConfigContextType {
  config: RuntimeConfig;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

interface ConfigProviderProps {
  config: RuntimeConfig;
  children: ReactNode;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({config, children}) => {
  return (
    <ConfigContext.Provider value={{config}}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = (): RuntimeConfig => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within ConfigProvider');
  }
  return context.config;
};

